import { render, staticRenderFns } from "./modalComfirm.vue?vue&type=template&id=5bcb1069&scoped=true&"
import script from "./modalComfirm.vue?vue&type=script&lang=js&"
export * from "./modalComfirm.vue?vue&type=script&lang=js&"
import style0 from "./modalComfirm.vue?vue&type=style&index=0&id=5bcb1069&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcb1069",
  null
  
)

export default component.exports